import React from 'react';

import ReactModal from 'react-modal';

import Close from '../assets/images/close.svg';

export default function FileModal({ fileOpen, toggleFileOpen, contract }) {
  const customStyles = {
    content: {
      maxWidth: '600px',
      display: 'flex',
      justifyContent: 'center',
      margin: '0 auto',
      padding: '16px',
    },
  };

  return (
    <ReactModal isOpen={fileOpen} style={customStyles}>
      <div className="amazon-documents-file__modal">
        <div className="amazon-documents-file__modal__header">
          <button onClick={toggleFileOpen} className="amazon-documents-file__modal__header__close">
            <img src={Close} alt="close" />
          </button>
        </div>
        <div className="amazon-documents-file__modal__embed">{contract}</div>
      </div>
    </ReactModal>
  );
}
